module.exports = __webpack_public_path__ + "media/images/return-item-afa8065f1b324a6f249fdd9b625df8f1.png";